module.exports = __webpack_public_path__ + "static/fonts/TTNorms-Regular.827b9d0.ttf";